<template>
  <div class="homeEnds box">
    <div class="close_box">
      <div class="main">
        <div class="logo_box">
          <h1>
            <img class="logo_ngo" src="img/logo_ngo.svg" alt="外交部非政府組織國際事務會">
            <img class="logo_text" src="img/logo_text.svg" alt="NGO 雙語網站">
          </h1>
        </div>

        <div class="text_box">
          <p class="title">「外交部NGO雙語網站使用者滿意度調查」已截止。</p>
          <p>
            得獎名單及相關資訊將公布於<a class="link" href="https://taiwanngo.tw/">NGO雙語網站</a>，敬請關注。
            感謝您的參與與支持！
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventEnd'
}
</script>
